/* eslint-disable @scandipwa/scandipwa-guidelines/use-namespace */
import { connect } from 'react-redux';

import WhyUsBlockComponent from './WhyUsBlock.component';

/** @namespace Component/WhyUsBlock/Container/mapStateToProps */
export const mapStateToProps = () => ({
    // Add any state mappings if needed
});

/** @namespace Component/WhyUsBlock/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
    // Add any dispatch mappings if needed
});

export default connect(mapStateToProps, mapDispatchToProps)(WhyUsBlockComponent);
